import RatingResponses from 'src/components/company/programs/Cohorts/ApplicationRating/RatingResponses/RatingResponses';
import ViewCohort from 'src/components/company/programs/viewCohort/ViewCohort';
import ViewUserCohort from 'src/components/profile/Cohorts/ViewCohort/ViewCohort';
import {
  MyProfile,
  ViewPostOwned,
  CreateCompany,
  MyCompany,
  Search,
  Settings,
  Chat,
  ViewEmptyIdea,
  ViewIdea,
  CreateProgram,
  ViewProgram,
  ViewProgramApplication,
  ViewMyApplication,
  Notifications
} from 'src/pages';
import CreateEvent from 'src/pages/CreateEvent/CreateEvent';
import MarketPlace from 'src/pages/MarketPlace/MarketPlace';
import MyVentureDetail from 'src/pages/my-venture/MyVenture';
import ViewEvent from 'src/pages/ViewEvent/ViewEvent';
import { TRoute } from 'src/types/routes.types';
import DemoDayRegister from 'src/pages/demo-day-register/DemoDayRegister';
import DemoDayDocumentSubmission from 'src/pages/demo-day-document-submission/DemoDayDocumentSubmission';
import DemoDaySlotBooking from 'src/pages/demo-day-slot-booking/DemoDaySlotBooking';
import DemoDaySuccess from 'src/pages/demo-day-success/DemoDaySuccess';
import DemoDayDetails from 'src/pages/demo-day-details/DemoDayDetails';
import DemoDayNotFound from 'src/pages/demo-day-not-found/DemoDayNotFound';
import IdeaDetailSimple from 'src/pages/idea-detail-simple/IdeaDetailSimple';
import ScoreCard from 'src/pages/score/ScoreCard';
import ScoreLanding from 'src/pages/scoring/ScoreLanding';
import InvestorCard from 'src/pages/investor/InvestorCard';
import StartupPaymentCard from 'src/pages/startup-payment/PaymentCard'
import TermsAndCondition from 'src/pages/termsandconditions/TermsAndCondition';
import StartupOnboarding from 'src/pages/startup-onboarding/StartupOnboarding';

const getProtectedRoutes: TRoute[] = [
  {
    name: 'chat',
    title: 'Chat',
    component: Chat,
    path: '/chat',
    availableToUserType: 'All'
  },
  {
    name: 'cohort',
    title: 'Cohort',
    component: ViewUserCohort,
    path: '/cohort',
    availableToUserType: 'User'
  },
  {
    name: 'cohort',
    title: 'Cohort',
    component: ScoreLanding,
    path: '/scoring',
    availableToUserType: 'User'
  },
  {
    name: 'cohort',
    title: 'Cohort',
    component: ScoreCard,
    path: '/score',
    availableToUserType: 'User'
  },
  {
    name: 'cohort',
    title: 'Cohort',
    component: StartupPaymentCard,
    path: '/startup-payment',
    availableToUserType: 'User'
  },
  {
    name: 'cohort',
    title: 'Cohort',
    component: StartupOnboarding,
    path: '/startup-onboarding',
    availableToUserType: 'User'
  },
  {
    name: 'cohort',
    title: 'Cohort',
    component: TermsAndCondition,
    path: '/termsandconditions',
    availableToUserType: 'User'
  },
  {
    name: 'cohort',
    title: 'Cohort',
    component: InvestorCard,
    path: '/investor',
    availableToUserType: 'User'
  },
  {
    name: 'view-post-owned',
    title: 'View Post Owned',
    component: ViewPostOwned,
    path: '/view-post-owned',
    availableToUserType: 'All'
  },
  {
    name: 'create-company',
    title: 'Create Company',
    component: CreateCompany,
    path: '/create-company',
    availableToUserType: 'All'
  },
  {
    name: 'my-company',
    title: 'View Company',
    component: MyCompany,
    path: '/my-company',
    availableToUserType: 'All'
  },
  {
    name: 'idea-detail-simple',
    title: 'Idea Detail Simple',
    component: IdeaDetailSimple,
    path: '/idea-detail',
    availableToUserType: 'User'
  },
  {
    name: 'view-empty-idea',
    title: 'View Empty Idea',
    component: ViewEmptyIdea,
    path: '/view-empty-idea',
    availableToUserType: 'User'
  },
  {
    name: 'search',
    title: 'Search',
    component: Search,
    path: '/search',
    availableToUserType: 'All'
  },
  {
    name: 'settings',
    title: 'Settings',
    component: Settings,
    path: '/settings',
    availableToUserType: 'All'
  },
  {
    name: 'view-idea',
    title: 'View Idea',
    component: ViewIdea,
    path: '/view-idea',
    availableToUserType: 'User'
  },
  {
    name: 'report-response',
    title: 'report response',
    component: RatingResponses,
    path: '/report-survey-response',
    availableToUserType: 'Company'
  },
  {
    name: 'my-profile',
    title: 'My Profile',
    component: MyProfile,
    path: '/my-profile',
    availableToUserType: 'All'
  },
  {
    name: 'create-event',
    title: 'Create event',
    component: CreateEvent,
    path: '/create-event',
    availableToUserType: 'Company'
  },
  {
    name: 'create-program',
    title: 'Create Program',
    component: CreateProgram,
    path: '/create-program',
    availableToUserType: 'Company'
  },
  {
    name: 'view-program',
    title: 'View Program',
    component: ViewProgram,
    path: '/view-program',
    availableToUserType: 'All'
  },
  {
    name: 'view-event',
    title: 'View Event',
    component: ViewEvent,
    path: '/view-event',
    availableToUserType: 'All'
  },
  {
    name: 'view-program-application',
    title: 'View Program Application',
    component: ViewProgramApplication,
    path: '/view-program-application',
    availableToUserType: 'All'
  },
  {
    name: 'view-my-application',
    title: 'View My Application',
    component: ViewMyApplication,
    path: '/view-my-application',
    availableToUserType: 'All'
  },
  {
    name: 'view-cohort',
    title: 'View Cohort',
    component: ViewCohort,
    path: '/view-cohort',
    availableToUserType: 'User'
  },
  {
    name: 'notifications',
    title: 'Notifications',
    component: Notifications,
    path: '/notifications',
    availableToUserType: 'All'
  },
  {
    name: 'marketplace',
    title: 'MarketPlace',
    component: MarketPlace,
    path: '/marketplace',
    availableToUserType: 'All'
  },
  {
    name: 'My Venture',
    title: 'My Venture',
    component: MyVentureDetail,
    path: '/my-venture',
    availableToUserType: 'All'
  },
  {
    name: 'Demo Day Registration',
    title: 'Demo Day Registration',
    component: DemoDayRegister,
    path: '/demo-day-register/payment',
    availableToUserType: 'All'
  },
  {
    name: 'Demo Day Document Submission',
    title: 'Demo Day Document Submission ',
    component: DemoDayDocumentSubmission,
    path: '/demo-day-register/document-submission',
    availableToUserType: 'All'
  },
  {
    name: 'Demo Day Slot Booking',
    title: 'Demo Day Slot Booking ',
    component: DemoDaySlotBooking,
    path: '/demo-day-register/slot-booking',
    availableToUserType: 'All'
  },
  {
    name: 'Demo Day Success',
    title: 'Demo Day Success ',
    component: DemoDaySuccess,
    path: '/demo-day-register/success',
    availableToUserType: 'All'
  },
  {
    name: 'Demo Day Detail',
    title: 'Demo Day Detail ',
    component: DemoDayDetails,
    path: '/demo-day-detail',
    availableToUserType: 'All'
  },
  {
    name: 'Demo Day Not Found',
    title: 'Demo Day Not Found ',
    component: DemoDayNotFound,
    path: '/not-found',
    availableToUserType: 'All'
  }

];

export default getProtectedRoutes;
